// src/pages/financials/ArAgingTab.tsx
//
// A/R Aging — thin wrapper around the shared AgingSection (recipe: qbd-ar-aging).

import { Receipt } from 'lucide-react';
import { AgingSection } from './AgingSection';

export function ArAgingTab() {
  return (
    <AgingSection
      kind="ar"
      title="A/R Aging"
      description="Open customer invoices by aging bucket, from QuickBooks Desktop."
      nameLabel="Customer"
      icon={Receipt}
    />
  );
}
